var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Operator',{attrs:{"disabled":_vm.disabled,"operators":_vm.operators,"value":_vm.compareType},on:{"update:value":function($event){_vm.compareType=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }